export enum Cursor {
    default = "default",
    pointer = "pointer",
    notAllowed = "not-allowed",
}
